"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyleWidth = void 0;
const getStyleWidth = size => {
  if (size === 'auto') return `auto`;
  const defaultSize = size ?? 12;
  const width = 100 / (12 / defaultSize);
  return `${Number(width.toFixed(2))}%`;
};
exports.getStyleWidth = getStyleWidth;